import { useActionState, useEffect, useState } from "react";
import { GreetingOccasionCategory } from "../../../../models";
import { GreetingOccasionCategoryViewModel } from "../../../../viewModels";
import { Button } from "../../../../components/button";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import GreetingOccasionSubcategoryService from "../../../../services/GreetingOccasionSubcategoryService";
import toast from "react-hot-toast";
import IconButton from "../../../../components/icon-button";
import { PlusIcon } from "@heroicons/react/24/outline";
import {
  createGreetingOccasionSubCategory,
  State,
} from "../actions/GreetingOccasionSubcategory";
import { useNavigate } from "react-router-dom";
import FormError from "../../../../components/form-error";

export default function GreetingOccasionSubcategoryCreateForm({
  category,
}: {
  category: GreetingOccasionCategoryViewModel;
}) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const api = new GreetingOccasionSubcategoryService();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };
  const [state, formAction, isPending] = useActionState(
    createGreetingOccasionSubCategory,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      toast.success("Subcategory created successfully");
      navigate(
        `/admin/greeting-occasion-categories/edit/${
          category.id
        }?reload=${Date.now()}`
      );
    }
  }, [state]);

  return (
    <form className="flex flex-col " action={formAction}>
      <div className="flex flex-1 gap-2 items-end">
        <div className="flex-1">
          <Label htmlFor="subcategory-name">Name</Label>
          <Input
            id="name"
            name="name"
            type="text"                        
            placeholder="Enter subcategory name"
            required
          />
          <input
            type="hidden"
            id="greetingOccasionCategoryId"
            name="greetingOccasionCategoryId"
            value={category.id}
          />
        </div>
        <IconButton
          label="Add Charity Issue"
          icon={PlusIcon}
          loading={isPending}
        ></IconButton>
      </div>
      <FormError id="name-error" message={state.errors?.name} />
    </form>
  );
}
